import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import TaglineBar from "./sections/TaglineBar";
import ProductCategoriesRow1 from "./sections/ProductCategoriesRow1";
import ProductCategoriesRow2 from "./sections/ProductCategoriesRow2";
import ClientLogos from "./sections/ClientLogos";
import Logodisplay from "./sections/Logodisplay";
import WelcomeAbout from "./sections/WelcomeAbout";
import ServicesMiningEquipment from "./sections/ServicesMiningEquipment";
import Imageshowcase from "./sections/Imageshowcase";
import FootprintAcrossAfrica from "./sections/FootprintAcrossAfrica";
import BrandsWeWorkWith from "./sections/BrandsWeWorkWith";
import ContactCta from "./sections/ContactCta";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroBanner />
      <TaglineBar />
      <ProductCategoriesRow1 />
      <ProductCategoriesRow2 />
      <ClientLogos />
      <Logodisplay />
      <WelcomeAbout />
      <ServicesMiningEquipment />
      <Imageshowcase />
      <FootprintAcrossAfrica />
      <BrandsWeWorkWith />
      <ContactCta />
      <Footer />
    </div>;
}